import React, { useState, useEffect, useRef, useContext, useAuthState } from "react";

import { redirect, Link, useNavigate } from "react-router-dom";

import { firestore, googleProvider, auth } from "../Database/firebase";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
/* import { AuthContext } from "./AuthProvider"; */



import { FaGoogle } from "react-icons/fa";

import { BsFillEyeFill, BsFillEyeSlashFill, BsPatchCheck, BsPatchCheckFill } from "react-icons/bs";

const ActivateCouponCodeios = () => {

    const [currentUser, setCurrentUser] = useState(null);

    const [message, setMessage] = useState("");

    const [passwordShown, setPasswordShown] = useState(false);


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const navigate = useNavigate();

    const refreshPage = () => {
        navigate(0);
    }

    const backPreviousPage = () => {
        navigate(-1);
    }

    var userAuth = auth.currentUser;
    var uid = "";
/* 
    if (userAuth != null) {
      
        navigate("/");
        
    } */

    
    const onEmailLogin = (e) => {
        e.preventDefault();
       
        
        const {email, password} = e.target.elements;
        
        auth
            .signInWithEmailAndPassword(email.value, password.value)
            .then((result) => {
                //setMessage("เข้าสู่ระบบเรียบร้อย");   
                //TEST AUTH PROVIDER
                setCurrentUser(true);
                ////////////////////
                navigate("/", { replace: true });
            })
            .catch((err) => {
                setMessage(err.code);
                setShow(true);
                console.log(message);
            });
    };

   

    const togglePassword = () => {
        // When the handler is invoked
        // chnage inverse the boolean state passwordShown
        setPasswordShown(!passwordShown);
      };


     /* const signOutHandler = () => {
        auth.signOut().then(() => {
            console.log("Log Out Ok");
            setCurrentUser(null);
            navigate("/");
        })
        .catch((err) => {
            console.log("Log Out Not Ok." + err);
        })
    }; */

    //TEST AUTH PROVIDER
   
    ////////////////////
    

    /* const authContext = useContext(AuthContext);

    var user = auth.currentUser;
    var email, uid; */

    /* if (user != null) {
        email = user.email;
        uid = user.uid;  
        console.log(email);

    } */


    
   

    return (

        <>

        <Modal 
                show={show} 
                onHide={handleClose} 
                animation={false} 
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                <Modal.Title>เข้าสู่ระบบไม่สำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>ไม่พบผู้ใช้/รหัสผ่านไม่ถูกต้อง กรุณาติดต่อแอดมิน</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        ปิด
                    </Button>
                </Modal.Footer>
        </Modal>


<Container style={{ maxWidth: 400 }}>
        <Form onSubmit={onEmailLogin} style={{ marginTop: 30, marginBottom: 110 }}>
        <br/>
        <br/>
        <br/>
        <br/>
        <h3 style={{fontWeight: 'bold'}}>การใช้งาน Coupon Code</h3>
        <p>กรอก Coupon Code ที่ได้รับเพื่ออ่านหนังสือผ่านแอพ EduLaw สำหรับอุปกรณ์ระบบ ios เช่น ipad, iphone</p>
       
        <br/>
        <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label><strong><span style={{fontSize: 20, color: 'goldenrod'}}><BsPatchCheckFill/></span> Activate Coupon Code (ios)</strong></Form.Label>
            <Form.Control type="email" name="email" className="form-control rounded-0" id="exampleInputEmail1" placeholder="กรุณากรอก Coupon Code" />
        </Form.Group>

       
        <br/>

        <div className="d-grid">
        <Button variant="primary" className="rounded-0" type="submit">
            กดใช้ Coupon Code
        </Button>
        </div>

        

        
        <br/>
        <br/>
        <br/>


{/*         <Form.Label><strong>Google Login</strong></Form.Label>
        <div className="d-grid">
        <Button onClick={googleLoginHandler} variant="outline-dark" className="rounded-0" type="submit">
            <FaGoogle/> เข้าสู่ระบบโดย Google 
        </Button>
        </div>

        <br/> */}


        <p style={ {borderBottom: '1px solid darkgray'} }></p>
        {/* <p>ยังไม่มีบัญชีใช่หรือไม่ ? <Link to={"/SignUp"}>สมัครใหม่</Link></p> */}
        </Form>

       
        
        </Container>

        </>

    );

}

export default ActivateCouponCodeios;